import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { formatWithFlag } from "app/utils"
import { FORM_URL } from 'app/@common/constants'

export default function SelectMarket({...props}) {
    const isSingleOption = props.totalOptions === 1
    const myProps = {
        urlAjax: FORM_URL.MARKET,
        isSearchable: false,
        placeholder: 'All markets',
        icon: { icon: 'globe-europe' },
        isMulti: true,
        formatOptionLabel: ({value}) => formatWithFlag(value, {countryName: true}),
        extraParams: props.idUser && {
            id_user: props.idUser
        },
        ...props
    }

    return <div className={`${props?.className}${isSingleOption ? ' disabled-select' : ''}`}>
        <SelectAjaxSeeker {...myProps} />
        {isSingleOption && <style jsx="true" global="true">{`
            .disabled-select {
                pointer-events: none;
                width: auto;
            }
            /* Aseguramos que la flecha desaparezca */
            .disabled-select [class*="indicatorContainer"] svg,
            .disabled-select [class*="IndicatorContainer"] svg,
            .disabled-select [class*="dropdown-indicator"] {
                display: none !important;
            }
        `}</style>}
    </div>
}